import * as types from '../actions/actionTypes';
import initialState from './initialState';
import {store} from '../index';
import {renuevaSessionUser, addUser} from '../actions/userActions';
import {showModalFinSession} from '../actions/finSessionActions';
import { Auth } from 'aws-amplify';


const tiempoRenovarSesion=1000*60*45;
const timepoFinDeSesion=1000*60*50;

var timer=0;
var timerLogout=0;

export function myTimer() {

    //var tiempoEjecutado = ((new Date()).getTime() - startTimeMS);
    //var tiempoParaSolicitar = 100*60*3;
    //console.log(timer);
    //console.log(tiempoEjecutado);
    //console.log(tiempoParaSolicitar);
    //if(tiempoEjecutado>=tiempoParaSolicitar){

    
        //clearTimeout(timer);
        //store.dispatch(showModalFinSession());
    
    
    
    //}
    
	if(store){			
        clearTimeout(timer);
		store.dispatch(renuevaSessionUser());    
	}
    
}
/*
export function signOut(){
    
        clearTimeout(timerLogout);
        clearTimeout(timer);
        
    
        try {
            Auth.signOut();
            store.dispatch(addUser(null));
            window.location.href = '/';
        } catch (error) {
            //console.log('error signing out: ', error);
        }
    }

*/

export default function userReducer(state= initialState.user, action){
	
	switch(action.type){
          
        case types.INIT_TIMER:	
        
             
			if(timer==0){	
                //startTimeMS = (new Date()).getTime();
				timer = setTimeout(myTimer, tiempoRenovarSesion);
                //timerLogout  = setTimeout(signOut, timepoFinDeSesion);
			}
			
			return state;
		break;	
            
        case types.RENOVAR_SESSION:	
            
         
            if(timer==0){
                 //startTimeMS = (new Date()).getTime();
                //clearTimeout(timerLogout);
	            clearTimeout(timer);
				timer = setTimeout(myTimer, tiempoRenovarSesion);
                //timerLogout  = setTimeout(signOut, timepoFinDeSesion);
			}else{
                //clearTimeout(timerLogout);
	            clearTimeout(timer);
                //startTimeMS = (new Date()).getTime();
			    //timer = setInterval(myTimer, tiempoRenovarSesion);
                timer = setTimeout(myTimer, tiempoRenovarSesion);
                //timerLogout  = setTimeout(signOut, timepoFinDeSesion);
            }
			
				
			return action.datos;
         
            
            
		break;
           
        
		case types.ADD_TOKEN:
            
			return action.datos;
		//break;		
		default:
			return state;
	}
}